import { mpx } from '@didi/es-mpx-creator';
import { USER_COLLECTION_TOC } from '../../api/urls';

// 获取个人信息
export const getPersonalInfoChecklist = (data) => {
  return mpx.$http.post(USER_COLLECTION_TOC, { data })
}